import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { NgStyle } from '@angular/common';
import { MatTooltipModule } from '@angular/material/tooltip';

@Component({
    selector: 'vshc-status-icon',
    templateUrl: './status-icon.component.html',
    styleUrls: ['./status-icon.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        NgStyle,
        MatTooltipModule
    ]
})
export class StatusIconComponent {

  @Input()
  color: string;

  @Input()
  text: string | number;

  @Input()
  tooltip: string;

  @Input()
  tooltipClass: string;

  @Input()
  fontSize: number;

  @Input()
  size = 20;

  @Input()
  count: number;

}
